import React, { useEffect, useState } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import {
  fetchGstMasters,
  createGstMaster,
  updateGstMaster,
  deleteGstMaster,
  fetchSupplierTypes
} from '../services/api';

const GstMasterPage = () => {
  const [gstList, setGstList] = useState([]);
  const [supplierTypes, setSupplierTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    mode: 'add',
    gst: {
      id: null,
      gstno: '',
      companyname: '',
      address: '',
      suppliertype: '',
      active: 'Active'
    }
  });

  const loadData = async () => {
    setLoading(true);
    const res = await fetchGstMasters();
    if (res.success) setGstList(res.data);
    else alert(res.message);

    const types = await fetchSupplierTypes();
    if (types.success) setSupplierTypes(types.data);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const openModal = (mode, gst = {
    id: null, gstno: '', companyname: '', address: '', suppliertype: '', active: 'Active',email:'',franchisee_email:''
  }) => {
    setModal({ open: true, mode, gst });
  };

  const closeModal = () => {
    setModal({
      open: false,
      mode: 'add',
      gst: { id: null, gstno: '', companyname: '', address: '', suppliertype: '', active: 'Active',email:'',franchisee_email:'' }
    });
  };

  const handleChange = (e) => {
    setModal({ ...modal, gst: { ...modal.gst, [e.target.name]: e.target.value } });
  };

  const handleSubmit = async () => {
    const { id, gstno, email,franchisee_email,companyname, address, suppliertype, active } = modal.gst;
    if (!gstno || !companyname || !suppliertype) return alert("All fields are required");

    const payload = { gstno, companyname,email,franchisee_email,address, suppliertype, active };
    const res = modal.mode === 'edit'
      ? await updateGstMaster(id, payload)
      : await createGstMaster(payload);

    if (res.success) {
      alert(`GST ${modal.mode === 'edit' ? 'updated' : 'added'} successfully`);
      closeModal();
      loadData();
    } else alert(res.message);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this GST record?')) return;
    const res = await deleteGstMaster(id);
    if (res.success) {
      alert('Deleted successfully');
      loadData();
    } else alert(res.message);
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>GST Master</h2>

        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button style={styles.addButton} onClick={() => openModal('add')}>
            <FaPlus style={{ marginRight: '6px' }} /> New GST
          </button>
        </div>

        {loading ? <p>Loading...</p> : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>GST No</th>
                <th style={styles.th}>Company Name</th>
                <th style={styles.th}>Email ID</th>
                <th style={styles.th}>Address</th>
                <th style={styles.th}>Supplier Type</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {gstList.map(g => (
                <tr key={g.id}>
                  <td style={styles.td}>{g.gstno}</td>
                  <td style={styles.td}>{g.companyname}</td>
                  <td style={styles.td}>{g.email}</td>
                  <td style={styles.td}>{g.address}</td>
                  <td style={styles.td}>{g.suppliertype_name || g.suppliertype}</td>
                  <td style={styles.td}>{g.active}</td>
                  <td style={styles.td}>
                    <button style={styles.iconButton} onClick={() => openModal('edit', g)}><FaEdit /></button>
                    <button style={styles.deleteButton} onClick={() => handleDelete(g.id)}><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {modal.open && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modalBox}>
              <h4>{modal.mode === 'edit' ? 'Edit' : 'Add'} GST</h4>
              <input name="gstno" placeholder="GST No" value={modal.gst.gstno} onChange={handleChange} style={styles.input} />
              <input name="companyname" placeholder="Company Name" value={modal.gst.companyname} onChange={handleChange} style={styles.input} />
              <textarea name="email" placeholder="Email ID" value={modal.gst.email} onChange={handleChange} style={styles.input}></textarea>
              <textarea name="franchisee_email" placeholder="Franchisee Email ID" value={modal.gst.franchisee_email} onChange={handleChange} style={styles.input}></textarea>
              <textarea name="address" placeholder="Address" value={modal.gst.address} onChange={handleChange} style={styles.input}></textarea>
              <select name="suppliertype" value={modal.gst.suppliertype} onChange={handleChange} style={styles.input}>
                <option value="">Select Supplier Type</option>
                {supplierTypes.map(s => (
                  <option key={s.id} value={s.id}>{s.suppliertype}</option>
                ))}
              </select>
              <select name="active" value={modal.gst.active} onChange={handleChange} style={styles.input}>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              <div style={{ marginTop: '20px' }}>
                <button style={styles.saveButton} onClick={handleSubmit}>Save</button>
                <button style={styles.cancelButton} onClick={closeModal}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: { padding: '30px' },
  heading: { fontSize: '24px', fontWeight: '600', marginBottom: '20px' },
  addButton: { padding: '10px 16px', fontSize: '16px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'center' },
  th: { padding: '12px', background: '#333', color: '#fff' },
  td: { padding: '10px', borderBottom: '1px solid #ddd' },
  iconButton: { marginRight: '8px', padding: '6px 10px', backgroundColor: '#ffc107', color: '#000', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  deleteButton: { padding: '6px 10px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' },
  modalBox: { background: '#fff', padding: '30px', borderRadius: '10px', width: '400px', textAlign: 'center' },
  input: { width: '100%', padding: '10px', margin: '10px 0', fontSize: '16px', borderRadius: '6px', border: '1px solid #ccc' },
  saveButton: { padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  cancelButton: { padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', marginLeft: '10px', cursor: 'pointer' }
};

export default GstMasterPage;
